export const educationData = [
  {
    id: 1,
    institution: "Oriental Institute of science and technology bhopal",
    course: "BTech",
    endYear: "2017",
  },
  {
    id: 2,
    institution: "SVM Harda",
    course: "12th math science",
    endYear: "2012",
  },
];
